import { CandidatePriority, NursingArea } from '../../candidate';
import { DOCIA_EMPLOYER_TYPE } from '../../employer';
import { SourceDomain } from '../../source-domain/source-domain';
import { JobTitleEnum } from '../job-titles.enum';
import { JobTitleDefinition } from './definition';

export type DociaJobTitleDefinition = JobTitleDefinition & { sourceDomains: SourceDomain[] };

const DOCIA_NURSING_AREAS = [NursingArea.Docia];
const DOCIA_TYPE_OF_EMPLOYER = DOCIA_EMPLOYER_TYPE;

export const DOCIA_MEDICAL_JOB_TITLES: DociaJobTitleDefinition[] = [
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 200,
    rank: 1,
    title: JobTitleEnum.ChiefPhysician,
    trackingPriority: CandidatePriority.B,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 201,
    rank: 1,
    title: JobTitleEnum.MedicalDirector,
    trackingPriority: CandidatePriority.B,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 202,
    rank: 1,
    title: JobTitleEnum.SeniorPhysician,
    trackingPriority: CandidatePriority.B,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 203,
    rank: 2,
    title: JobTitleEnum.SpecialistPhysician,
    trackingPriority: CandidatePriority.A,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 204,
    rank: 2,
    title: JobTitleEnum.ResidentPhysician,
    trackingPriority: CandidatePriority.D,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 205,
    rank: 3,
    title: JobTitleEnum.PracticeAcquisition,
    trackingPriority: CandidatePriority.E,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 206,
    rank: 4,
    title: JobTitleEnum.MedicalStudent,
    trackingPriority: CandidatePriority.F,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
];

export const DOCIA_DENTAL_JOB_TITLES: DociaJobTitleDefinition[] = [
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 207,
    rank: 1,
    title: JobTitleEnum.Orthodontist,
    trackingPriority: CandidatePriority.B,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 208,
    rank: 1,
    title: JobTitleEnum.OralSurgeon,
    trackingPriority: CandidatePriority.B,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 209,
    rank: 1,
    title: JobTitleEnum.MkgSurgeon,
    trackingPriority: CandidatePriority.B,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 210,
    rank: 2,
    title: JobTitleEnum.EmployedDentist,
    trackingPriority: CandidatePriority.A,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 211,
    rank: 2,
    title: JobTitleEnum.DentalTrainingAssistant,
    trackingPriority: CandidatePriority.F,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 212,
    rank: 2,
    title: JobTitleEnum.PediatricDentist,
    trackingPriority: CandidatePriority.D,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
  {
    area: DOCIA_NURSING_AREAS,
    deputy: false,
    order: 213,
    rank: 4,
    title: JobTitleEnum.DentalPrepAssistant,
    trackingPriority: CandidatePriority.F,
    typeOfEmployer: DOCIA_TYPE_OF_EMPLOYER,
    sourceDomains: [SourceDomain.DociaDe],
  },
];

export const DOCIA_JOB_TITLES: DociaJobTitleDefinition[] = [...DOCIA_MEDICAL_JOB_TITLES, ...DOCIA_DENTAL_JOB_TITLES];
